// Header.js
import React from 'react';
import { FaSun, FaMoon, FaExpand, FaCompress } from 'react-icons/fa';

const Header = ({ toggleTheme, theme, handleFullScreen, isFullScreen }) => {
  return (
    <header className="header">
      <h1>Quizzap, conteúdos e quizzes que conectam e engajam!</h1>
      
      <div className="controls">
        {/* Controle de Tema */}
        <div onClick={toggleTheme} className="themeToggle" title={theme === 'light' ? 'Ativar Tema Escuro' : 'Ativar Tema Claro'}>
          {theme === 'light' ? <FaMoon /> : <FaSun />}
        </div>
        
        {/* Controle de Tela Cheia */}
        <div onClick={handleFullScreen} className="fullScreenToggle" title={isFullScreen ? 'Sair de Tela Cheia' : 'Entrar em Tela Cheia'}>
          {isFullScreen ? <FaCompress /> : <FaExpand />}
        </div>
      </div>
    </header>
  );
};

export default Header;
